export default __webpack_public_path__ + "static/media/packageAlt.b04de665.svg";